import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolService } from "../../../../../shared/services/school.service";
import { DataService_RoleAdminSU } from "../../shared/data.service";
import { RoleAdminSuUsersAddRolesRequest } from "../../shared/RoleAdminSuUsersAddRolesRequest";

@Component({
	selector: "app-role-admin-su-no-roles-add-roles",
	templateUrl: "./role-admin-su-no-roles-add-roles.component.html",
	styleUrls: ["./role-admin-su-no-roles-add-roles.component.css"],
})
export class RoleAdminSuNoRolesAddRolesComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private schoolService: SchoolService,
		private dataService: DataService_RoleAdminSU
	) {}

	ngOnInit(): void {
		this.lstSelectedUsers = this.dialogConfig.data.lstSelectedUsers;
		this.UserCount = this.lstSelectedUsers.length;

		for (var z = 0; z < this.lstSelectedUsers.length; z++) {
			var next = this.lstSelectedUsers[z];

			if (next.UserLevelID == 3) {
				this.SchoolUserCount++;
			} else if (next.UserLevelID == 1) {
				this.DistrictUserCount++;
			}
		}

		this.loadSchools();
		this.loadRoles();
	}

	////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////

	lstSelectedUsers: any = [];
	UserCount: number = 0;
	DistrictUserCount: number = 0;
	SchoolUserCount: number = 0;

	SchoolOption: string = "Home"; //Home | List

	schoolpagerows: any = 5;
	schoolpagefirst: any = 0;

	SelectedSchools: any = [];
	lstSchool: any = [];

	rolepagerows: any = 5;
	rolepagefirst: any = 0;

	SelectedRoles: any = [];
	lstRole: any = [];

	SchoolLoading: boolean = false;
	RoleLoading: boolean = false;
	Processing: boolean = false;

	errorMessage: string = "";

	////////////////////////////////////////////////////

	////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////

	loadSchools() {
		this.SchoolLoading = true;

		var result = this.schoolService.loadSchoolListWithOptions("All", -1);
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				this.SchoolLoading = false;
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	loadRoles() {
		this.RoleLoading = true;

		// Default to District
		var UserLevelID = 1;

		// If any of the selected users are school level, only allow school level roles
		for (var z = 0; z < this.lstSelectedUsers.length; z++) {
			var next = this.lstSelectedUsers[z];

			if (next.UserLevelID == 3) {
				UserLevelID = 3;
				break;
			}
		}

		var result = this.dataService.RoleWithPagesGetList(UserLevelID, -1, 1);
		result.subscribe(
			(response) => {
				this.lstRole = response;

				this.RoleLoading = false;
			},
			(error) => {
				this.RoleLoading = false;
			}
		);
	}

	////////////////////////////////////////////////////

	////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////

	onAddRoles() {
		this.errorMessage = "";

		if (this.SchoolOption == "List") {
			if (this.SelectedSchools.length == 0) {
				this.errorMessage = "Select which school(s) you want the users to have access to";
				return;
			}
		} else {
			this.SelectedSchools.unshift({
				SchoolID: -1,
				SchoolName: "User's Home School",
			});
		}

		if (this.SelectedRoles.length == 0) {
			this.errorMessage = "Select which role(s) you want the users to have access to";
			return;
		}

		var Msg = "";

		if (this.SelectedSchools.length == 1) {
			if (this.SchoolOption == "Home") {
				if (this.SelectedRoles.length == 1) {
					Msg =
						"Are you sure you want to give " +
						this.UserCount +
						" user" +
						(this.UserCount == 1 ? "" : "s") +
						' the role "' +
						this.SelectedRoles[0].RoleDesc +
						'" at their home school' +
						"?";
				}
				if (this.SelectedRoles.length > 1) {
					Msg =
						"Are you sure you want to give " +
						this.UserCount +
						" user" +
						(this.UserCount == 1 ? "" : "s") +
						" " +
						this.SelectedRoles.length +
						'" roles at their home school' +
						"?";
				}
			} else if (this.SchoolOption == "List") {
				if (this.SelectedRoles.length == 1) {
					Msg =
						"Are you sure you want to give " +
						this.UserCount +
						" user" +
						(this.UserCount == 1 ? "" : "s") +
						' the role "' +
						this.SelectedRoles[0].RoleDesc +
						'" at ' +
						this.SelectedSchools[0].SchoolName +
						"?";
				}
				if (this.SelectedRoles.length > 1) {
					Msg =
						"Are you sure you want to give " +
						this.UserCount +
						" user" +
						(this.UserCount == 1 ? "" : "s") +
						" " +
						this.SelectedRoles.length +
						" roles at " +
						this.SelectedSchools[0].SchoolName +
						"?";
				}
			}
		}

		if (this.SelectedSchools.length > 1) {
			if (this.SelectedRoles.length == 1) {
				Msg =
					"Are you sure you want to give " +
					this.UserCount +
					" user" +
					(this.UserCount == 1 ? "" : "s") +
					' the role "' +
					this.SelectedRoles[0].RoleDesc +
					'" at' +
					this.SelectedSchools.length +
					" schools?";
			}
			if (this.SelectedRoles.length > 1) {
				Msg =
					"Are you sure you want to give " +
					this.UserCount +
					" user" +
					(this.UserCount == 1 ? "" : "s") +
					" " +
					this.SelectedRoles.length +
					" roles at" +
					this.SelectedSchools.length +
					" schools?";
			}
		}

		this.confirmationService.confirm({
			key: "NoRoleAddConfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Add Roles",
			icon: "fa",
			accept: () => {
				this.onFinishAddRoles();
			},
		});
	}

	onFinishAddRoles() {
		this.Processing = true;

		var lstUID = this.lstSelectedUsers.map((item) => item.UserID);
		var lstSID = this.SelectedSchools.map((item) => item.SchoolID);
		var lstRID = this.SelectedRoles.map((item) => item.RoleID);

		var parms: RoleAdminSuUsersAddRolesRequest = {
			lstUserIDs: lstUID,
			lstSchoolIDs: lstSID,
			lstRoleIDs: lstRID,
		};

		var result = this.dataService.RoleAdminSuUserAddRoles(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "NoRoleAdd",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Users were assigned roles successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "NoRoleAdd",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add roles to the users: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////////////

	IsLoading() {
		return this.SchoolLoading == true || this.RoleLoading == true || this.Processing == true;
	}
}
